<template>
    <carousel class="slider" @changed="$emit('change')" :nav="false" :dots="false" :items="numberOfItems">
      <template #prev>
        <div class="nav-control left disabled">
          <i class="fal fa-chevron-left"></i>
        </div>
      </template>
      <slot></slot>
      <template #next>
        <div class="nav-control right">
          <i class="fal fa-chevron-right"></i>
        </div>
      </template>
    </carousel>
</template>

<script>
  import carousel from 'vue-owl-carousel';

  export default {
    components: { carousel },
    computed: {
        numberOfItems () {
            if (matchMedia('(max-width: 767px)').matches) {
                return 1.5;
            } else {
                return 3;
            }
        }
    }
  }
</script>
